import { render } from "./TabInvoices.vue?vue&type=template&id=48cecfb5"
import script from "./TabInvoices.vue?vue&type=script&lang=js"
export * from "./TabInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__